import { Box, Button, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconRefresh, IconWifiOff } from "@tabler/icons-react";

export const NoConnectionPage: React.FC<{ onRetry: () => void }> = ({ onRetry }) => (
    <Box
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Stack align="center" >
        <ThemeIcon size={80} radius="xl" color="red" variant="light">
          <IconWifiOff size={40} />
        </ThemeIcon>
        
        <Text size="xl" fw={600} color="dimmed">
          No Internet Connection
        </Text>
        
        <Text size="md" color="dimmed" style={{ maxWidth: 400 }}>
          Please check your internet connection and try again. Make sure you're connected to a stable network.
        </Text>
        
        <Button 
          rightSection={<IconRefresh size={16} />}
          onClick={onRetry}
          variant="outline"
          size="md"
        >
          Retry Connection
        </Button>
      </Stack>
    </Box>
  );